export const ApiDebugList: any = [
  {
    name: "API 接口文档",
    key: "0",
    data: [
      // {
      //   // 接口名称
      //   name: "创建用户Key API",
      //   // 接口key
      //   key: "0_0",
      //   // 请求方法
      //   method: "POST",
      //   // 描述
      //   description: "创建用户Key接口用于为当前登录用户生成一个新的API访问密钥。这个密钥可以用来替代JWT Token进行API认证，特别适合长期使用的场景，比如第三方应用集成或自动化脚本。",
      //   // 域名
      //   domain: "window.location.origin",
      //   // 端点
      //   endpoint: "/api/user-key/create-user-key",
      //   // 请求头
      //   requestHeaders: [
      //     {
      //       // 当前请求头键
      //       key: "Authorization",
      //       // 当前请求头值（由于会用到各种选择条件，使用使用数组和字符串双格式，数组——列表选择器，date——时间选择器，textArea——输入框）
      //       value: [`Bearer ${localStorage.getItem("token")}`],
      //       // 当前请求头描述
      //       description: "鉴权参数，示例：Bearer xxxxxx",
      //       // 当前请求头是否必填
      //       required: true
      //     },
      //     {
      //       key: "Content-Type",
      //       value: ["application/json"],
      //       description: "解释请求正文的方式",
      //       required: true
      //     },
      //   ],
      //   // 请求体
      //   requestBody: [
      //     {
      //       key: "expiresAt",
      //       value: "date",
      //       // defaultValue: [new Intl.DateTimeFormat('en-CA', {
      //       //   timeZone: 'Asia/Shanghai'
      //       // }).format(new Date(Date.now() + 7 * 86400000))],
      //       description: "Key的过期时间（YYYY-MM-DD），默认过期时间为7天",
      //       required: false
      //     },
      //   ],
      //   // 响应示例
      //   responseExample: {
      //     "uuid": "550e8400-e29b-41d4-a716-446655440000",
      //     "userId": "user-uuid",
      //     "key": "uk_abc123def456ghi789",
      //     "status": "active",
      //     "expiresAt": "2025-09-28T14:02:09.690Z",
      //     "lastUsedAt": null,
      //     "usageCount": 0,
      //     "createdAt": "2025-09-21T22:02:09.698Z",
      //     "updatedAt": "2025-09-21T22:02:09.698Z",
      //     "user": {
      //       "uuid": "d1ae5ce9-0a86-4862-9424-2acef936fbc9",
      //       "username": "admin",
      //       "nickname": "管理员",
      //       "email": "tony@medboxdata.com"
      //     }
      //   },
      //   // 字段说明
      //   fieldDescription: {
      //     columns: [
      //       { title: "字段名", dataIndex: "name", width: 180 },
      //       { title: "类型", dataIndex: "type", width: 120 },
      //       { title: "描述", dataIndex: "description" },
      //     ],
      //     data: [
      //       {
      //         name: "uuid",
      //         type: "string",
      //         description:
      //           "Key的全局唯一标识符，用于系统内部识别和管理该Key",
      //       },
      //       {
      //         name: "userId",
      //         type: "string",
      //         description:
      //           "创建该Key的用户ID，对应用户表中的唯一标识",
      //       },
      //       {
      //         name: "key",
      //         type: "string",
      //         description:
      //           "实际使用的API密钥，格式为 uk_+随机字符串，用于API调用时的身份验证",
      //       },
      //       {
      //         name: "status",
      //         type: "string",
      //         description:
      //           "Key的当前状态：active-正常可用；expired-已过期；revoked-已撤销",
      //       },
      //       {
      //         name: "expiresAt",
      //         type: "string",
      //         description:
      //           "Key的过期时间，ISO 8601格式，过期后Key将自动失效",
      //       },
      //       {
      //         name: "lastUsedAt",
      //         type: "string/null",
      //         description:
      //           "最后一次使用该Key的时间，ISO 8601格式；从未使用则为 null",
      //       },
      //       {
      //         name: "usageCount",
      //         type: "number",
      //         description:
      //           "该Key已被使用的总次数，用于统计和监控API调用频率",
      //       },
      //       {
      //         name: "createdAt",
      //         type: "string",
      //         description: "Key的创建时间，ISO 8601格式",
      //       },
      //       {
      //         name: "updatedAt",
      //         type: "string",
      //         description: "Key的最后更新时间，ISO 8601格式",
      //       },
      //       {
      //         name: "uuid(user)",
      //         type: "string",
      //         description: "用户的全局唯一标识符",
      //       },
      //       {
      //         name: "username(user)",
      //         type: "string",
      //         description: "用户的登录用户名，用于系统登录",
      //       },
      //       {
      //         name: "nickname(user)",
      //         type: "string",
      //         description: "用户的显示昵称，用于界面展示",
      //       },
      //       {
      //         name: "email(user)",
      //         type: "string",
      //         description:
      //           "用户的邮箱地址，用于接收通知和找回密码",
      //       },
      //     ],
      //   },
      //   // 响应状态
      //   responseStatus: {
      //     columns: [
      //       {
      //         title: "http异常码",
      //         dataIndex: "code",
      //         // width: 150,
      //       },
      //       { title: "消息体", dataIndex: "body" },
      //       { title: "异常原因", dataIndex: "cause" },
      //       { title: "处理方式", dataIndex: "method" },
      //     ],
      //     data: [
      //       {
      //         code: 400,
      //         body: `{
      //                 "statusCode": 400,
      //                 "message": "Validation failed",
      //                 "error": "Bad Request",
      //                 "details": [
      //                   {
      //                     "field": "expiresAt",
      //                     "message": "expiresAt must be a valid date string"
      //                   }
      //                 ]
      //               }`,
      //         cause: "过期时间格式不正确",
      //         method: "使用 YYYY-MM-DD 格式的日期字符串",
      //       },
      //       {
      //         code: 401,
      //         body: `{
      //                 "statusCode": 401,
      //                 "message": "Unauthorized",
      //                 "error": "Unauthorized"
      //               }`,
      //         cause: "JWT Token无效或已过期",
      //         method: "请重新登录获取新的Token",
      //       },
      //       {
      //         code: 429,
      //         body: `{
      //                 "statusCode": 429,
      //                 "message": "Too Many Requests",
      //                 "error": "Too Many Requests"
      //               }`,
      //         cause: "短时间内创建Key次数过多",
      //         method: "请稍后再试，建议控制创建频率",
      //       },
      //       {
      //         code: 500,
      //         body: `{
      //                 "statusCode": 500,
      //                 "message": "Internal server error",
      //                 "error": "Internal Server Error"
      //               }`,
      //         cause: "服务器暂时无法处理请求",
      //         method: "请稍后重试，如果问题持续请联系技术支持",
      //       },
      //     ],
      //   },
      //   // SDK 示例
      //   SDKExample: [
      //     {
      //       name: '使用cURL命令',
      //       code: `curl -X POST "${window.location.origin}/api/user-key/create-user-key" 
      //   -H "Authorization: Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9..." 
      //   -H "Content-Type: application/json" 
      //   -d '{
      //     "expiresAt": "2025-12-31"
      //   }'`
      //     },
      //     {
      //       name: '使用Node (Fetch API)',
      //       code: `async function createUserKey(jwtToken) {
      //   try {
      //     const response = await fetch('${window.location.origin}/api/user-key/create-user-key', {
      //       method: 'POST',
      //       headers: {
      //         'Authorization': \`Bearer \${ jwtToken }\`,
      //         'Content-Type': 'application/json'
      //       },
      //       body: JSON.stringify({
      //         expiresAt: '2025-12-31'  // 可选，不填则默认30天后过期
      //       })
      //     });

      //     if (!response.ok) {
      //       throw new Error(\`HTTP error! status: \${ response.status }\`);
      //     }

      //     const result = await response.json();
      //     console.log('新创建的Key:', result.key);
      //     return result;
      //   } catch (error) {
      //     console.error('创建Key失败:', error);
      //   }
      // }

      // // 使用示例
      // const myJwtToken = 'your_jwt_token_here';
      // createUserKey(myJwtToken);
      //               `
      //     },
      //     {
      //       name: '使用Python (requests库)',
      //       code: `import requests
      // import json

      // def create_user_key(jwt_token, expires_at=None):
      //     url = "${window.location.origin}/api/user-key/create-user-key"
      //     headers = {
      //         "Authorization": f"Bearer {jwt_token}",
      //         "Content-Type": "application/json"
      //     }

      //     data = {}
      //     if expires_at:
      //         data["expiresAt"] = expires_at

      //     try:
      //         response = requests.post(url, headers=headers, json=data)
      //         response.raise_for_status()

      //         result = response.json()
      //         print(f"新创建的Key: {result['key']}")
      //         return result
      //     except requests.exceptions.RequestException as e:
      //         print(f"创建Key失败: {e}")
      //         return None

      // # 使用示例
      // my_jwt_token = "your_jwt_token_here"
      // new_key = create_user_key(my_jwt_token, "2025-12-31")`
      //     }
      //   ],
      //   // 注意事项
      //   precautions: [
      //     "安全保管： 创建的Key具有完全的API访问权限，请妥善保管，不要泄露给他人。",
      //     "定期轮换： 建议定期更换API Key，特别是在团队协作或系统集成场景下。",
      //     "使用统计： 可以通过'获取用户Key'接口查看Key的使用情况，包括最后使用时间和使用次数。",
      //     "批量管理： 如果需要创建多个Key，建议在管理界面批量操作；API调用时请控制频率，避免触发限制。",
      //     "过期提醒： Key过期前系统会发送提醒，但建议主动检查和管理Key的生命周期。"
      //   ]
      // },
      // {
      //   name: "获取用户Key API",
      //   key: "0_1",
      //   method: "GET",
      //   description: "获取用户Key接口用于查询当前登录用户创建的所有API访问密钥。这个接口会返回用户的所有活跃Key信息，包括Key的状态、使用统计、过期时间等。",
      //   domain: "window.location.origin",
      //   endpoint: "/api/user-key/get-user-key",
      //   requestHeaders: [
      //     {
      //       key: "Authorization",
      //       value: 'textArea',
      //       description: "鉴权参数，使用用户Key进行认证，示例：uk_abc123def456ghi789",
      //       required: true
      //     },
      //     {
      //       key: "Content-Type",
      //       value: ["application/json"],
      //       description: "解释请求正文的方式",
      //       required: true
      //     },
      //   ],
      //   requestBody: [
      //     {
      //       key: "无",
      //       value: "无",
      //       description: "无",
      //       required: false
      //     },
      //   ],
      //   responseExample: [
      //     {
      //       "uuid": "550e8400-e29b-41d4-a716-446655440000",
      //       "userId": "user-uuid",
      //       "key": "uk_abc123def456ghi789",
      //       "status": "active",
      //       "expiresAt": "2025-12-31T00:00:00.000Z",
      //       "lastUsedAt": "2024-09-20T10:30:00.000Z",
      //       "usageCount": 25,
      //       "createdAt": "2024-09-01T09:00:00.000Z",
      //       "updatedAt": "2024-09-20T10:30:00.000Z"
      //     },
      //     {
      //       "uuid": "550e8400-e29b-41d4-a716-446655440001",
      //       "userId": "user-uuid",
      //       "key": "uk_xyz789uvw321lmn456",
      //       "status": "expired",
      //       "expiresAt": "2024-08-15T00:00:00.000Z",
      //       "lastUsedAt": "2024-08-10T14:20:00.000Z",
      //       "usageCount": 150,
      //       "createdAt": "2024-07-15T11:00:00.000Z",
      //       "updatedAt": "2024-08-15T00:00:00.000Z"
      //     }
      //   ],
      //   fieldDescription: {
      //     columns: [
      //       { title: "字段名", dataIndex: "name", width: 180 },
      //       { title: "类型", dataIndex: "type", width: 120 },
      //       { title: "描述", dataIndex: "description" },
      //     ],
      //     data: [
      //       {
      //         name: "uuid",
      //         type: "string",
      //         description:
      //           "Key的全局唯一标识符，用于系统内部识别和管理该Key",
      //       },
      //       {
      //         name: "userId",
      //         type: "string",
      //         description:
      //           "创建该Key的用户ID，对应用户表中的唯一标识",
      //       },
      //       {
      //         name: "key",
      //         type: "string",
      //         description:
      //           "实际使用的API密钥，格式为uk_+随机字符串，用于API调用时的身份验证",
      //       },
      //       {
      //         name: "status",
      //         type: "string",
      //         description:
      //           "Key的当前状态：active-正常可用；expired-已过期；revoked-已撤销",
      //       },
      //       {
      //         name: "expiresAt",
      //         type: "string",
      //         description:
      //           "Key的过期时间，采用ISO 8601格式的时间戳，过期后Key将自动失效",
      //       },
      //       {
      //         name: "lastUsedAt",
      //         type: "string/null",
      //         description:
      //           "最后一次使用该Key的时间，采用ISO 8601格式，如果从未使用则为null",
      //       },
      //       {
      //         name: "usageCount",
      //         type: "number",
      //         description:
      //           "该Key已被使用的总次数，用于统计和监控API调用频率",
      //       },
      //       {
      //         name: "createdAt",
      //         type: "string",
      //         description: "Key的创建时间，采用ISO 8601格式的时间戳",
      //       },
      //       {
      //         name: "updatedAt",
      //         type: "string",
      //         description: "Key的最后更新时间，采用ISO 8601格式的时间戳",
      //       },
      //     ],
      //   },
      //   responseStatus: {
      //     columns: [
      //       {
      //         title: "http异常码",
      //         dataIndex: "code",
      //       },
      //       { title: "消息体", dataIndex: "body" },
      //       { title: "异常原因", dataIndex: "cause" },
      //       { title: "处理方式", dataIndex: "method" },
      //     ],
      //     data: [
      //       {
      //         code: 401,
      //         body: `{
      //                 "statusCode": 401,
      //                 "message": "Unauthorized",
      //                 "error": "Unauthorized"
      //               }`,
      //         cause: "User Key无效或已过期",
      //         method: "请检查User Key是否正确，或重新创建新的Key",
      //       },
      //       {
      //         code: 500,
      //         body: `{
      //                 "statusCode": 500,
      //                 "message": "Internal server error",
      //                 "error": "Internal Server Error"
      //               }`,
      //         cause: "服务器暂时无法处理请求",
      //         method: "请稍后重试，如果问题持续请联系技术支持",
      //       },
      //     ],
      //   },
      //   SDKExample: [
      //     {
      //       name: '使用cURL命令',
      //       code: `curl -X GET "window.location.origin/api/user-key/get-user-key" 
      //   -H "Authorization: uk_abc123def456ghi789"`
      //     },
      //     {
      //       name: '使用Node (Fetch API)',
      //       code: `async function getUserKeys(userKey) {
      //   try {
      //     const response = await fetch('window.location.origin/api/user-key/get-user-key', {
      //       method: 'GET',
      //       headers: {
      //         'Authorization': \`uk_\${ userKey }\`
      //       }
      //     });

      //     if (!response.ok) {
      //       throw new Error(\`HTTP error! status: \${ response.status }\`);
      //     }

      //     const keys = await response.json();
      //     console.log('用户Keys:', keys);

      //     // 统计信息
      //     const activeKeys = keys.filter(key => key.status === 'active');
      //     const totalUsage = keys.reduce((sum, key) => sum + key.usageCount, 0);

      //     console.log(\`活跃Keys: \${ activeKeys.length }, 总使用次数: \${ totalUsage }\`);

      //     return keys;
      //   } catch (error) {
      //     console.error('获取Keys失败:', error);
      //   }
      // }

      // // 使用示例
      // const myUserKey = 'abc123def456ghi789'; // 不包含uk_前缀
      // getUserKeys(myUserKey);`
      //     },
      //     {
      //       name: '使用Python (requests库)',
      //       code: `import requests

      // def get_user_keys(user_key):
      //     url = "window.location.origin/api/user-key/get-user-key"
      //     headers = {
      //         "Authorization": f"uk_{user_key}"
      //     }

      //     try:
      //         response = requests.get(url, headers=headers)
      //         response.raise_for_status()

      //         keys = response.json()
      //         print(f"获取到 {len(keys)} 个Keys")

      //         # 分析Keys状态
      //         active_count = sum(1 for key in keys if key['status'] == 'active')
      //         expired_count = sum(1 for key in keys if key['status'] == 'expired')
      //         total_usage = sum(key['usageCount'] for key in keys)

      //         print(f"活跃: {active_count}, 已过期: {expired_count}, 总使用: {total_usage}")

      //         return keys
      //     except requests.exceptions.RequestException as e:
      //         print(f"获取Keys失败: {e}")
      //         return None

      // # 使用示例
      // my_user_key = "abc123def456ghi789"  # 不包含uk_前缀
      // user_keys = get_user_keys(my_user_key)`
      //     }
      //   ],
      //   precautions: [
      //     "权限控制： 只能查看自己创建的Keys，无法查看其他用户的Keys",
      //     "状态监控： 定期检查Keys的状态，及时处理过期或异常的Keys",
      //     "使用统计： 通过usageCount和lastUsedAt字段了解Key的使用情况",
      //     "性能考虑： 该接口返回所有Keys，建议定期调用获取最新状态",
      //     "安全提醒： 虽然只能查看自己的Keys，但仍建议谨慎处理返回的敏感信息",
      //     "批量操作准备： 获取Keys列表后，可以为批量删除或其他管理操作做准备"
      //   ]
      // },
      // {
      //   name: "删除用户Key API",
      //   key: "0_2",
      //   method: "POST",
      //   description: "删除用户Key接口用于批量删除当前用户创建的API访问密钥。这个接口支持删除单个或多个Key，可以根据Key的UUID进行精确删除。",
      //   domain: "window.location.origin",
      //   endpoint: "/api/user-key/delete-user-keys",
      //   requestHeaders: [
      //     {
      //       key: "Authorization",
      //       value: "textArea",
      //       description: "鉴权参数，使用用户Key进行认证，示例：uk_abc123def456ghi789",
      //       required: true
      //     },
      //     {
      //       key: "Content-Type",
      //       value: ["application/json"],
      //       description: "解释请求正文的方式",
      //       required: true
      //     },
      //   ],
      //   requestBody: [
      //     {
      //       key: "uuids",
      //       value: "textArea",
      //       description: "要删除的Key UUID数组，至少包含一个UUID，示例：['uuid']",
      //       required: true
      //     },
      //   ],
      //   responseExample: {
      //     "success": true,
      //     "deletedCount": 2,
      //     "message": "成功删除 2 个用户密钥",
      //     "deletedKeys": [
      //       "uk_abc123def456ghi789",
      //       "uk_xyz789uvw321lmn456"
      //     ]
      //   },
      //   fieldDescription: {
      //     columns: [
      //       { title: "字段名", dataIndex: "name", width: 180 },
      //       { title: "类型", dataIndex: "type", width: 120 },
      //       { title: "描述", dataIndex: "description" },
      //     ],
      //     data: [
      //       {
      //         name: "success",
      //         type: "boolean",
      //         description:
      //           "操作是否成功",
      //       },
      //       {
      //         name: "deletedCount",
      //         type: "number",
      //         description:
      //           "实际删除的Key数量",
      //       },
      //       {
      //         name: "message",
      //         type: "string",
      //         description:
      //           "操作结果描述信息",
      //       },
      //       {
      //         name: "deletedKeys",
      //         type: "Array<string>",
      //         description:
      //           "被删除的Key列表（显示Key字符串而非UUID）",
      //       },
      //     ],
      //   },
      //   responseStatus: {
      //     columns: [
      //       {
      //         title: "http异常码",
      //         dataIndex: "code",
      //       },
      //       { title: "消息体", dataIndex: "body" },
      //       { title: "异常原因", dataIndex: "cause" },
      //       { title: "处理方式", dataIndex: "method" },
      //     ],
      //     data: [
      //       {
      //         code: 400,
      //         body: `{
      //                 "statusCode": 400,
      //                 "message": "Validation failed", 
      //                 "error": "Bad Request",
      //               "details": [
      //                 {
      //                 "field": "uuids",
      //                 "message": "uuids must be an array"
      //                 }
      //                 ]
      //               }`,
      //         cause: "请求参数格式错误，uuids不是有效数组或为空",
      //         method: "检查uuids参数，确保是包含至少一个UUID的数组",
      //       },
      //       {
      //         code: 401,
      //         body: `{
      //                 "statusCode": 401,
      //                 "message": "Unauthorized",
      //                 "error": "Unauthorized"
      //               }`,
      //         cause: "User Key无效或已过期",
      //         method: "请检查User Key是否正确，或重新创建新的Key",
      //       },
      //       {
      //         code: 403,
      //         body: `{
      //                 "statusCode": 403,
      //                 "message": "Forbidden",
      //                 "error": "Forbidden"
      //               }`,
      //         cause: "尝试删除不属于自己的Keys",
      //         method: "只能删除自己创建的Keys，无法删除其他用户的Keys",
      //       },
      //       {
      //         code: 404,
      //         body: `{
      //                 "statusCode": 404,
      //                 "message": "Keys not found", 
      //                 "error": "Not Found"
      //               }`,
      //         cause: "部分或全部UUID对应的Key不存在",
      //         method: "检查UUID是否正确，可能已经被删除或从未存在",
      //       },
      //       {
      //         code: 429,
      //         body: `{
      //                 "statusCode": 429,
      //                 "message": "Too Many Requests",
      //                 "error": "Too Many Requests"
      //               }`,
      //         cause: "短时间内创建Key次数过多",
      //         method: "请稍后再试，建议控制创建频率",
      //       },
      //       {
      //         code: 500,
      //         body: `{
      //                 "statusCode": 500,
      //                 "message": "Internal server error",
      //                 "error": "Internal Server Error"
      //               }`,
      //         cause: "服务器暂时无法处理请求",
      //         method: "请稍后重试，如果问题持续请联系技术支持",
      //       },
      //     ],
      //   },
      //   SDKExample: [
      //     {
      //       name: '使用cURL命令',
      //       code: `curl -X POST "window.location.origin/api/user-key/delete-user-keys" 
      //   -H "Authorization: uk_abc123def456ghi789" 
      //   -H "Content-Type: application/json" 
      //   -d '{
      //     "uuids": [
      //       "550e8400-e29b-41d4-a716-446655440000",
      //       "550e8400-e29b-41d4-a716-446655440001"
      //     ]
      //   }'`
      //     },
      //     {
      //       name: '使用Node (Fetch API)',
      //       code: `async function deleteUserKeys(userKey, keyUuids) {
      //   try {
      //     const response = await fetch('window.location.origin/api/user-key/delete-user-keys', {
      //       method: 'POST',
      //       headers: {
      //         'Authorization': \`uk_\${ userKey }\`,
      //         'Content-Type': 'application/json'
      //       },
      //       body: JSON.stringify({
      //         uuids: keyUuids
      //       })
      //     });

      //     if (!response.ok) {
      //       throw new Error(\`HTTP error! status: \${ response.status }\`);
      //     }

      //     const result = await response.json();
      //     console.log('删除结果:', result.message);
      //     console.log(\`成功删除 \${ result.deletedCount } 个Keys\`);

      //     return result;
      //   } catch (error) {
      //     console.error('删除Keys失败:', error);
      //   }
      // }

      // // 使用示例
      // const myUserKey = 'abc123def456ghi789'; // 不包含uk_前缀
      // const keysToDelete = [
      //   '550e8400-e29b-41d4-a716-446655440000',
      //   '550e8400-e29b-41d4-a716-446655440001'
      // ];

      // deleteUserKeys(myUserKey, keysToDelete);`
      //     },
      //     {
      //       name: '使用Python (requests库)',
      //       code: `import requests
      // import json

      // def delete_user_keys(user_key, key_uuids):
      //     url = "window.location.origin/api/user-key/delete-user-keys"
      //     headers = {
      //         "Authorization": f"uk_{user_key}",
      //         "Content-Type": "application/json"
      //     }

      //     data = {
      //         "uuids": key_uuids
      //     }

      //     try:
      //         response = requests.post(url, headers=headers, json=data)
      //         response.raise_for_status()

      //         result = response.json()
      //         print(result['message'])
      //         print(f"成功删除 {result['deletedCount']} 个Keys")

      //         return result
      //     except requests.exceptions.RequestException as e:
      //         print(f"删除Keys失败: {e}")
      //         return None

      // # 使用示例
      // my_user_key = "abc123def456ghi789"  # 不包含uk_前缀
      // keys_to_delete = [
      //     "550e8400-e29b-41d4-a716-446655440000",
      //     "550e8400-e29b-41d4-a716-446655440001"
      // ]

      // result = delete_user_keys(my_user_key, keys_to_delete)`
      //     }
      //   ],
      //   precautions: [
      //     "操作不可逆： 删除Keys是永久性操作，无法恢复，请谨慎操作",
      //     "权限验证： 只能删除自己创建的Keys，无法删除其他用户的Keys",
      //     "批量删除： 支持一次删除多个Keys，提高管理效率",
      //     "部分成功： 如果某些UUID不存在或无权限，系统会删除有权限的Keys并返回相应信息",
      //     "安全考虑： 删除不需要的Keys可以提高账户安全性，建议定期清理",
      //     "使用频率： 避免频繁调用此接口，建议批量处理删除操作"
      //   ]
      // },
      {
        name: "数据库RAG切片 API",
        key: "0_3",
        method: "POST",
        description: "数据库RAG切片API用于根据用户问题进行完整的检索增强生成（Retrieval-Augmented Generation）流程。这个接口集成了先进的向量搜索和重排序技术，能够从海量文档中快速找到最相关的知识点，并返回精准的答案片段。",
        domain: window.location.origin,
        endpoint: "/api/arg-slice/slice/content",
        requestHeaders: [
          {
            key: "Authorization",
            value: [],
            description: "鉴权参数，使用用户Key进行认证，示例：uk_abc123def456ghi789",
            required: true
          },
          // {
          //   key: "Content-Type",
          //   value: ["application/json"],
          //   description: "解释请求正文的方式",
          //   required: true
          // },
        ],
        requestBody: [
          {
            key: "query",
            value: "textArea",
            description: "用户的问题文本，用于进行语义检索",
            required: true
          },
          {
            key: "limit",
            value: "textArea",
            description: "返回结果数量限制，范围1-20，默认5",
            required: false
          },
          {
            key: "app",
            value: ['gbi'],
            description: "应用名称，默认为'gbi'",
            required: false
          },
          {
            key: "queryType",
            value: ['simple', 'deep', 'research'],
            description: "查询类型：simple(简单)、deep(深入)、research(研究)，默认'simple'",
            required: false
          },
          {
            key: "enableReranking",
            value: ['true', 'false'],
            description: "是否启用重排序，默认true",
            required: false
          },
        ],
        responseExample: {
          "success": true,
          "data": [
            {
              "uuid": "550e8400-e29b-41d4-a716-446655440000",
              "sliceIndex": 5,
              "content": "... [前文省略] ...\n\n医疗器械注册是指医疗器械生产企业按照国家相关法规和标准要求，向药品监督管理部门提出注册申请，获得批准后方可生产、销售的程序。医疗器械注册是确保医疗器械安全、有效、质量可控的重要环节。\n\n... [后文省略] ...",
              "similarityScore": 0.85,
              "type": "content",
              "metadata": {
                "source_type": "content",
              }
            },
            {
              "uuid": "550e8400-e29b-41d4-a716-446655440001",
              "sliceIndex": -1,
              "content": "医疗器械注册管理办法",
              "similarityScore": 0.78,
              "type": "title",
              "metadata": {
                "source_type": "title",
              }
            }
          ]
        },
        fieldDescription: {
          columns: [
            { title: "字段名", dataIndex: "name", width: 180 },
            { title: "类型", dataIndex: "type", width: 120 },
            { title: "描述", dataIndex: "description" },
          ],
          data: [
            {
              name: "success",
              type: "boolean",
              description:
                "请求是否成功",
            },
            {
              name: "data",
              type: "array",
              description:
                "检索结果数组，按相关性排序",
            },
            {
              name: "uuid(data)",
              type: "string",
              description:
                "文档切片的唯一标识符",
            },
            {
              name: "sliceIndex(data)",
              type: "number",
              description:
                "切片索引，-1表示标题，0-N表示内容切片",
            },
            {
              name: "content(data)",
              type: "string",
              description:
                "切片的具体文本内容",
            },
            {
              name: "similarityScore(data)",
              type: "number",
              description:
                "向量相似度分数，0-1之间",
            },
            {
              name: "type(data)",
              type: "string",
              description:
                "切片类型：title(标题)、content(内容)、summary(摘要)",
            },
            {
              name: "metadata(data)",
              type: "object",
              description:
                "元数据信息，包含来源类型、文档标题等",
            },
          ],
        },
        responseStatus: {
          columns: [
            {
              title: "http异常码",
              dataIndex: "code",
            },
            { title: "消息体", dataIndex: "body" },
            { title: "异常原因", dataIndex: "cause" },
            { title: "处理方式", dataIndex: "method" },
          ],
          data: [
            {
              code: 400,
              body: `{
                "statusCode": 400,
                "message": "Validation failed", 
                "error": "Bad Request"
              }`,
              cause: "请求参数格式错误，query字段为空或格式不正确",
              method: "检查query参数是否为非空字符串",
            },
            {
              code: 401,
              body: `{
                "statusCode": 401,
                "message": "Unauthorized",
                "error": "Unauthorized"
              }`,
              cause: "认证失败，Token或Key无效",
              method: "检查Authorization头是否正确，或重新获取有效的认证凭据",
            },
            {
              code: 429,
              body: `{
                "statusCode": 429,
                "message": "Too Many Requests", 
                "error": "Too Many Requests"
              }`,
              cause: "请求频率过高，触发限流",
              method: "降低请求频率，建议间隔至少1秒",
            },
            {
              code: 500,
              body: `{
                "statusCode": 500,
                "message": "Internal server error", 
                "error": "Internal Server Error"
              }`,
              cause: "服务器内部错误，通常是检索或排序服务异常",
              method: "请稍后重试，如果问题持续请联系技术支持",
            },
          ],
        },
        SDKExample: [
          {
            name: '使用cURL命令',
            code: `curl -X POST "window.location.origin/api/arg-slice/slice/content" 
  -H "Authorization: uk_abc123def456ghi789" 
  -H "Content-Type: application/json" 
  -d '{
    "query": "《药品注册管理办法》对药品注册信息公开的具体要求有哪些？",
    "limit": 1,
    "queryType": "simple",
    "enableReranking": true
  }'`
          },
          {
            name: '使用Node (Fetch API)',
            code: `async function searchRelatedContent(userKey, query, options = {}) {
  try {
    const requestBody = {
      query: query,
      limit: options.limit || 5,
      app: options.app || 'gbi',
      queryType: options.queryType || 'simple',
      enableReranking: options.enableReranking !== false
    };

    const response = await fetch('window.location.origin/api/arg-slice/slice/content', {
      method: 'POST',
      headers: {
        'Authorization': \`uk_\${ userKey }\`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(requestBody)
    });

    if (!response.ok) {
      throw new Error(\`HTTP error! status: \${ response.status }\`);
    }

    const result = await response.json();
    console.log(\`找到 \${ result.data.length } 个相关内容\`);
    
    // 处理检索结果
    result.data.forEach((item, index) => {
      console.log(\`   相似度: \${ item.similarityScore.toFixed(3) }\`);
      console.log(\`   内容: \${ item.content.substring(0, 100) }...\`);
      console.log('---');
    });
    
    return result.data;
  } catch (error) {
    console.error('RAG检索失败:', error);
  }
}

// 使用示例
const myUserKey = 'abc123def456ghi789';
searchRelatedContent(myUserKey, '什么是医疗器械注册？', { limit: 3 });`
          },
          {
            name: '使用Python (requests库)',
            code: `import requests
import json

def search_rag_content(user_key, query, limit=5, query_type='simple', enable_reranking=True):
    url = "window.location.origin/api/arg-slice/slice/content"
    headers = {
        "Authorization": f"uk_{user_key}",
        "Content-Type": "application/json"
    }
    
    data = {
        "query": query,
        "limit": limit,
        "queryType": query_type,
        "enableReranking": enable_reranking
    }
    
    try:
        response = requests.post(url, headers=headers, json=data)
        response.raise_for_status()
        
        result = response.json()
        print(f"检索成功，找到 {len(result['data'])} 个相关内容")
        
        # 分析结果
        for i, item in enumerate(result['data'], 1):
            print(".3f")
            print(".3f")
            print(f"   内容: {item['content'][:100]}...")
            print("-" * 50)
        
        return result['data']
    except requests.exceptions.RequestException as e:
        print(f"RAG检索失败: {e}")
        return None

# 使用示例
my_user_key = "abc123def456ghi789"
results = search_rag_content(my_user_key, "什么是医疗器械注册？", limit=3)`
          }
        ],
        precautions: [
          "查询优化： 建议使用完整的句子进行查询，这样能获得更好的检索效果",
          "结果限制： limit参数建议设置为3-10，过多结果可能影响处理效率",
          "重排序选项： enableReranking=true可以显著提升结果质量，建议保持开启",
          "性能考虑： 向量搜索较为耗时，建议合理控制查询频率",
          "缓存策略： 相同查询会自动使用缓存结果，提升响应速度",
          "数据更新： 系统会定期更新索引，确保检索到最新的文档内容",
          "错误处理： 建议在客户端实现完善的错误处理逻辑，特别是网络超时情况"
        ]
      },
      {
        name: "政策问答 API",
        key: "0_4",
        method: "POST",
        description: "政策问答API用于基于用户问题进行智能政策分析，支持流式回答和多种对话模式。",
        domain: window.location.origin,
        endpoint: "/api/policy-qa/stream",
        requestHeaders: [
          {
            key: "Authorization",
            value: [],
            description: "鉴权参数，使用用户Key进行认证，示例：uk_abc123def456ghi789",
            required: true
          },
          // {
          //   key: "Content-Type",
          //   value: ["application/json"],
          //   description: "解释请求正文的方式",
          //   required: true
          // },
        ],
        requestBody: [
          {
            key: "type",
            value: ['simple', 'deep', 'research'],
            description: "问答类型：simple(简洁)、deep(深入)、research(研究)",
            required: true
          },
          {
            key: "query",
            value: "textArea",
            description: "用户的问题内容",
            required: true
          },
          {
            key: "thinking",
            value: ['true', 'false'],
            description: "是否使用推理模型，默认false",
            required: false
          },
          // {
          //   key: "history",
          //   value: "Array",
          //   description: "对话历史记录",
          //   required: false
          // },
          // {
          //   key: "enhancedContext",
          //   value: "object",
          //   description: "增强上下文（由深度搜索服务提供）",
          //   required: false
          // },
          {
            key: "useVector",
            value: ['true', 'false'],
            description: "是否使用向量搜索，默认true",
            required: false
          },
          {
            key: "useFulltext",
            value: ['true', 'false'],
            description: "是否使用全文搜索，默认true",
            required: false
          },
          {
            key: "rerank",
            value: ['true', 'false'],
            description: "是否对结果重排序，默认true",
            required: false
          },
          {
            key: "app",
            value: ['gbi'],
            description: "应用名称，默认'gbi'",
            required: false
          },
          // {
          //   key: "apps",
          //   value: "Array<string>",
          //   description: "多个应用名称",
          //   required: false
          // },
          {
            key: "dateStart",
            value: "textArea",
            description: "开始日期，格式YYYY-MM-DD",
            required: false
          },
          {
            key: "dateEnd",
            value: "textArea",
            description: "结束日期，格式YYYY-MM-DD",
            required: false
          },
          // {
          //   key: "fileName",
          //   value: "Array<string>",
          //   description: "文件名列表",
          //   required: false
          // },
          // {
          //   key: "indexName",
          //   value: "Array<string>",
          //   description: "索引号列表",
          //   required: false
          // },
        ],
        responseExample: {
          "success": true,
          "data": {
            "id": "chatcmpl-final",
            "object": "chat.completion",
            "created": 1677858245,
            "model": "deepseek-r1-250528",
            "choices": [{
              "index": 0,
              "message": {
                "role": "assistant",
                "content": "医疗器械注册是指医疗器械生产企业按照国家相关法规和标准要求，向药品监督管理部门提出注册申请，获得批准后方可生产、销售的程序。这是确保医疗器械安全、有效、质量可控的重要环节。"
              },
              "finish_reason": "stop"
            }],
            "usage": {
              "prompt_tokens": 150,
              "completion_tokens": 200,
              "total_tokens": 350
            },
            "sources": [
              {
                "title": "医疗器械注册管理办法",
                "uuid": "doc-uuid-123",
                "date": "2023-12-01",
                "source_type": "policy",
                "file_name": "国家药监局令第45号"
              }
            ],
            "relatedQuestions": [
              "医疗器械注册流程有哪些步骤？",
              "医疗器械注册需要提交哪些材料？"
            ]
          }
        },
        fieldDescription: {
          columns: [
            { title: "字段名", dataIndex: "name", width: 180 },
            { title: "类型", dataIndex: "type", width: 120 },
            { title: "描述", dataIndex: "description" },
          ],
          data: [
            {
              name: "id",
              type: "string",
              description:
                "会话唯一标识符",
            },
            {
              name: "object",
              type: "string",
              description:
                "对象类型，通常为'chat.completion'",
            },
            {
              name: "created",
              type: "number",
              description:
                "创建时间戳",
            },
            {
              name: "model",
              type: "string",
              description:
                "使用的AI模型名称",
            },
            {
              name: "choices",
              type: "array",
              description:
                "回答选项数组",
            },
            {
              name: "usage",
              type: "object",
              description:
                "Token使用统计",
            },
            {
              name: "sources",
              type: "array",
              description:
                "参考资料来源",
            },
            {
              name: "relatedQuestions",
              type: "array",
              description:
                "相关问题推荐",
            },
          ],
        },
        responseStatus: {
          columns: [
            {
              title: "http异常码",
              dataIndex: "code",
            },
            { title: "消息体", dataIndex: "body" },
            { title: "异常原因", dataIndex: "cause" },
            { title: "处理方式", dataIndex: "method" },
          ],
          data: [
            {
              code: 400,
              body: `{
                "statusCode": 400,
                "message": "Validation failed", 
                "error": "Bad Request"
              }`,
              cause: "请求参数格式错误，缺少必需字段或格式不正确",
              method: "检查请求体的必填字段和格式，特别是type和query字段",
            },
            {
              code: 401,
              body: `{
                "statusCode": 401,
                "message": "Unauthorized",
                "error": "Unauthorized"
              }`,
              cause: "认证失败，Token或Key无效",
              method: "检查Authorization头是否正确，或重新获取有效的认证凭据",
            },
            {
              code: 429,
              body: `{
                "statusCode": 429,
                "message": "Too Many Requests", 
                "error": "Too Many Requests"
              }`,
              cause: "请求频率过高，触发限流",
              method: "降低请求频率，建议间隔至少1秒",
            },
            {
              code: 500,
              body: `{
                "statusCode": 500,
                "message": "Internal server error", 
                "error": "Internal Server Error"
              }`,
              cause: "服务器内部错误",
              method: "请稍后重试，如果问题持续请联系技术支持",
            },
          ],
        },
        SDKExample: [
          {
            name: '使用cURL命令',
            code: `curl -X POST "window.location.origin/api/policy-qa/stream" 
  -H "Authorization: uk_abc123def456ghi789" 
  -H "Content-Type: application/json" 
  -d '{
    "type": "simple",
    "query": "《药品注册管理办法》对药品注册信息公开的具体要求有哪些？",
    "thinking": false,
    "history": []
  }'`
          },
          {
            name: '使用Node (Fetch API)',
            code: `async function askPolicyQuestion(userKey, question, type = 'simple') {
  try {
    const response = await fetch('window.location.origin/api/policy-qa/stream', {
      method: 'POST',
      headers: {
        'Authorization': \`uk_\${ userKey }\`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        type: type,
        query: question,
        thinking: false,
        history: [],
        useVector: true,
        useFulltext: true,
        rerank: true
      })
    });

    if (!response.ok) {
      throw new Error(\`HTTP error! status: \${ response.status }\`);
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let fullContent = '';

    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
      
      const chunk = decoder.decode(value);
      const lines = chunk.split('\n');
      
      for (const line of lines) {
        if (line.startsWith('data: ')) {
          const data = JSON.parse(line.slice(6));
          if (data.choices && data.choices[0].delta.content) {
            fullContent += data.choices[0].delta.content;
            process.stdout.write(data.choices[0].delta.content);
          }
        }
      }
    }
    
    console.log('\n回答完成');
    return fullContent;
  } catch (error) {
    console.error('问答请求失败:', error);
  }
}

// 使用示例
const myUserKey = 'abc123def456ghi789';
askPolicyQuestion(myUserKey, '《药品注册管理办法》对药品注册信息公开的具体要求有哪些？');`
          },
          {
            name: '使用Python (requests库)',
            code: `import requests
import json
import sseclient

def ask_policy_question(user_key, question, qa_type='simple'):
    url = "window.location.origin/api/policy-qa/stream"
    headers = {
        "Authorization": f"uk_{user_key}",
        "Content-Type": "application/json"
    }
    
    data = {
        "type": qa_type,
        "query": question,
        "thinking": False,
        "history": [],
        "useVector": True,
        "useFulltext": True,
        "rerank": True
    }
    
    try:
        response = requests.post(url, headers=headers, json=data, stream=True)
        response.raise_for_status()
        
        client = sseclient.SSEClient(response)
        full_content = ''
        
        for event in client.events():
            if event.data:
                try:
                    data = json.loads(event.data)
                    if data.get('choices') and data['choices'][0].get('delta', {}).get('content'):
                        content = data['choices'][0]['delta']['content']
                        full_content += content
                        print(content, end='', flush=True)
                except json.JSONDecodeError:
                    continue
        
        print('\n回答完成')
        return full_content
    except requests.exceptions.RequestException as e:
        print(f"问答请求失败: {e}")
        return None

# 使用示例
my_user_key = "abc123def456ghi789"
answer = ask_policy_question(my_user_key, "《药品注册管理办法》对药品注册信息公开的具体要求有哪些？")`
          }
        ],
        precautions: [
          "流式响应处理： 客户端需要正确处理SSE流式响应，实时显示内容",
          "认证方式： 建议使用User Key进行认证，避免JWT Token过期问题",
          "参数选择： 根据问题复杂度选择合适的type参数，复杂问题建议使用'research'模式",
          "对话历史： 保持适当的history长度，避免过长的上下文影响性能",
          "错误处理： 流式响应中可能包含错误信息，需要正确解析和处理",
          "性能考虑： thinking=true会显著增加响应时间，请根据需要选择",
          "数据时效性： 系统会优先使用最新的政策数据，但建议定期验证信息准确性"
        ]
      }
    ]
  }
];

export const ConsoleList = [
  {
    name: '密钥管理',
    key: '0',
    data: [
      {
        name: 'API 密钥管理',
        key: '0_0'
      }
    ]
  }
]